import { Controller } from "@hotwired/stimulus";

/**
 * Copies text to the clipboard when clicked.
 *
 * If nested within a tooltip controller, it will temporarily replace the
 * tooltip's content with "Copied!" before restoring the original.
 *
 * Values:
 *   text - the string to copy to the clipboard
 *
 * Example:
 *   <%= render "shared/tooltip", content: "Copy link" do %>
 *     <button data-controller="clipboard"
 *             data-clipboard-text-value="<%= project_url %>"
 *             data-action="click->clipboard#copy">
 *       <%= icon "link" %>
 *     </button>
 *   <% end %>
 */
export default class extends Controller {
  static values = { text: String };

  connect() {
    const tooltipEl = this.element.closest("[data-controller~='tooltip']");
    if (tooltipEl) {
      this.tooltip = this.application.getControllerForElementAndIdentifier(tooltipEl, "tooltip");
      this.originalLabel = this.tooltip.contentTarget.textContent;
    }
  }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      if (this.tooltip) {
        this.tooltip.contentTarget.textContent = "Copied!";
        setTimeout(() => {
          this.tooltip.contentTarget.textContent = this.originalLabel;
          this.tooltip.hide();
        }, 2000);
      }
    });
  }
}
